import React, { useEffect, useContext } from 'react';
import Inputs from 'components/inputs/inputs';
import Flow from 'components/common/flow/flow';
import Panel from 'components/common/panel/panel';
import Heading from 'components/common/heading/heading';
import AppContext from 'contexts/appContext';
import SiteContext from 'components/shared/siteContext/siteContext';

const styles = {
  numberLabel: {
    width: '100px',
  },
  numberInput: {
    display: 'inline',
    width: '70px',
    textAlign: 'center',
  }
};

export default function MenusPage() {
  const { setAppArea, setAppBreadcrumb } = useContext(AppContext);

  useEffect(() => {
    setAppArea(AppContext.Areas.Menus, 'Manage Menus');
    setAppBreadcrumb([{ name: 'Home', href: '/' }, { name: 'Menus', selected: true }]);
  }, []);

  const screens = [
    {
      id: 1,
      name: 'PARTY PLATTERS TO GO',
    },
    {
      id: 2,
      name: 'IN HOUSE PLATTERS',
    },
    {
      id: 3,
      name: 'HOLIDAY DESSERT COUPON',
    },
    {
      id: 13,
      name: 'ENTREES',
    },
    {
      id: 22,
      name: '*BREAKFAST OPTIONS',
    },
  ];

  return (
    <Flow>
      <Flow.Header>
        <Heading>
          <SiteContext.Button loaded={true} hierarchyId={141} onSelectSite={() => null} />
        </Heading>
      </Flow.Header>

      <Flow.Body>
        {/*<div className='d-flex justify-content-center mt-3'>
          <div className=''>
            <div style={styles.numberLabel}>Jump to screen:</div>
            <Inputs.Integer
              required
              min='1'
              max='999'
              style={styles.numberInput}
            />
          </div>
          <div className=''>
            <div style={styles.numberLabel}>Jump to item:</div>
            <Inputs.Integer
              required
              min='1'
              max='999'
              style={styles.numberInput}
            />
          </div>
        </div>*/}
        <div className='row mx-0 mt-4'>
          <MenuScreenPanel screens={screens} start={1} count={10} />
          <MenuScreenPanel screens={screens} start={11} count={10} />
          <MenuScreenPanel screens={screens} start={21} count={10} />
          <MenuScreenPanel screens={screens} start={31} count={10} />
          <MenuScreenPanel screens={screens} start={41} count={10} />
          <MenuScreenPanel screens={screens} start={51} count={10} />
          <MenuScreenPanel screens={screens} start={61} count={10} />
          <MenuScreenPanel screens={screens} start={71} count={10} />
          <MenuScreenPanel screens={screens} start={81} count={10} />
          <MenuScreenPanel screens={screens} start={91} count={10} />
          <MenuScreenPanel screens={screens} start={101} count={10} />
          <MenuScreenPanel screens={screens} start={111} count={10} />
        </div>
      </Flow.Body>
    </Flow>
  );
}

function MenuScreenPanel(props) {
  const renderRows = () => {
    const rows = [];
    for (let i = props.start; i < props.start + props.count; i++) {
      const screen = props.screens.find(a => a.id === i);
      rows.push(<MenuRow title={screen?.name} id={i} />);
    }
    return rows;
  };

  return (
    <div className='col-12 col-md-6 col-xl-4'>
      <Panel>
        <Panel.Header>
          Screens {props.start}-{props.start + props.count - 1}
        </Panel.Header>
        <Panel.Body>
          <ul className='list-group list-group-flush'>
            {renderRows()}
          </ul>
        </Panel.Body>
      </Panel>
    </div>
  );
}

function MenuRow(props) {
  return (
    <a href={`/Menus/Screen/${props.id}`} className='list-group-item list-group-item-action' key={props.id}>{props.id}-{props.title}</a>
  );
}